import React from "react";
import { Checkbox as AntdCheckbox } from "antd";

const Checkbox = ({
	defaultChecked,
	dispatch,
	name,
	questionId,
	lookup,
	isNew,
	dataType,
	...otherProps
}) => {
	const [answerAdded, answerEdited] = dispatch;
	const handleDispatch = (e) => {
		let data = {
			questionId: questionId,
			value: e,
			id: name,
			dataType: dataType,
		};
		if (!isNew) answerEdited(data);
		else answerAdded(data);
	};
	const options =
		lookup && lookup.map((l) => ({ label: l.description, value: l.code }));
	return lookup ? (
		<AntdCheckbox.Group
			options={options}
			onChange={handleDispatch}
			defaultChecked={defaultChecked}
			{...otherProps}
		/>
	) : (
		<p>Error: a checkbox was rendered but no lookup list was passed</p>
	);
};

export default Checkbox;
